import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { getOnFleetErrorLogByShop, getSynchronizedTeamsByShop } from '../../actions/integration'

import {
  Grid,
  Button,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
  ListItem,
  MenuItem,
  Tabs,
  Tab,
  Paper,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { EditableSelect, EditableSwitch } from '../common/EditableComponents'
import { updateShop } from '../../actions/shop'
import OnFleetSettingInfoShopSettings from '../OnFleet/OnFleetSettingInfoShopSettings'
import OnFleetSettingInfoOrdenNotes from '../OnFleet/OnFleetSettingInfoOrdenNotes'
import OnFleetSettingInfoMemberNotes from '../OnFleet/OnFleetSettingInfoMemberNotes'

const onFleetSettingsTabs = ['Shop Settings', 'Order Notes', 'Member Notes']

class OnFleetSettingInfoItem extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      shopFeatures: {},
      activeSettingTab: 'Shop Settings',
      OnFleetSettingInfo: {},
      onFleetErrorLogs: [],
      onFleetTeamInfo: {},
    }
  }

  componentDidMount() {
    const { shop = {} } = this.props
    this.props.dispatch(getOnFleetErrorLogByShop({ shopId: shop.id })).then((res) => {
      this.setState({
        onFleetErrorLogs: res.values || [],
      })
    })
    this.props.dispatch(getSynchronizedTeamsByShop({ shopId: shop.id })).then((res) => {
      this.setState({
        onFleetTeamInfo: res || {},
      })
    })
  }

  renderSettingTab = (activeSettingTab) => {
    const {
      shop = {},
      autoOnFleetIncomingOrders = null,
      shopFeatures = [],
      onfleetTwoWaysEnabled = false,
    } = this.props

    switch (activeSettingTab) {
      case 'Order Notes':
        return (
          <OnFleetSettingInfoOrdenNotes
            shop={shop}
            onfleetSettings={shopFeatures.onfleetSetting}
            shopFeatures={shopFeatures}
            autoOnFleetIncomingOrders={autoOnFleetIncomingOrders}
          />
        )
      case 'Member Notes':
        return (
          <OnFleetSettingInfoMemberNotes
            shop={shop}
            onfleetSettings={shopFeatures.onfleetSetting}
            shopFeatures={shopFeatures}
            autoOnFleetIncomingOrders={autoOnFleetIncomingOrders}
          />
        )
      case 'Shop Settings':
        return (
          <OnFleetSettingInfoShopSettings
            shop={shop}
            autoOnFleetIncomingOrders={autoOnFleetIncomingOrders}
            onfleetTwoWaysEnabled={onfleetTwoWaysEnabled}
          />
        )
      default:
        return null
    }
  }

  onFleetSettingsTabs = onFleetSettingsTabs.map((tab) => <Tab label={tab} value={tab} />)

  handleChange = (event, tab) => {
    this.setState({
      activeSettingTab: tab,
    })
  }

  render() {
    const { shop = {}, index, selectedPanel } = this.props
    const { activeSettingTab } = this.state

    return (
      <ExpansionPanel
        className="margin-top-small"
        expanded={selectedPanel === index}
        onChange={this.props.selectPanel(index)}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="title" gutterBottom className="tab-heading">
            {shop.name}
          </Typography>
        </ExpansionPanelSummary>
        <div>
          <Paper>
            <Tabs
              value={activeSettingTab}
              onChange={this.handleChange}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              {this.onFleetSettingsTabs}
            </Tabs>
          </Paper>
          {this.renderSettingTab(activeSettingTab)}
        </div>
      </ExpansionPanel>
    )
  }
}

export default connect(({ dispatch }) => ({ dispatch }))(OnFleetSettingInfoItem)



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetSettingInfoItem.js